// Maps blog slug -> raw markdown string. Bodies are imported via webpack's
// `asset/source` rule (see craco.config.js). Empty entries fall through to a
// "Coming soon" placeholder in the detail page.
import riseOfAgenticAi from "./blogs/rise-of-agentic-ai.md";
import productionVoiceAgents from "./blogs/production-voice-agents-architecture.md";
import mlSystemDesign from "./blogs/ml-system-design-billion-rps.md";
import multiAgentPatterns from "./blogs/multi-agent-coordination-patterns.md";
import llmFinetuning from "./blogs/llm-finetuning-domain-specific.md";
import ragVsFinetuning from "./blogs/rag-vs-finetuning.md";
import audioJourneyStt from "./blogs/journey-of-an-audio-frame-through-stt.md";

export const BLOG_BODIES = {
  "rise-of-agentic-ai": riseOfAgenticAi,
  "production-voice-agents-architecture": productionVoiceAgents,
  "ml-system-design-billion-rps": mlSystemDesign,
  "multi-agent-coordination-patterns": multiAgentPatterns,
  "llm-finetuning-domain-specific": llmFinetuning,
  "rag-vs-finetuning": ragVsFinetuning,
  "journey-of-an-audio-frame-through-stt": audioJourneyStt,
};
